import React from 'react';
import { Link } from 'react-router-dom';

const SiblingLinks = ({ items = [], className = 'cy-fineprint', style }) => {
  if (!items.length) return null;
  return (
    <p className={className} style={style || { marginTop: 32 }}>
      {items.map((s, i) => (
        <React.Fragment key={s.to}>
          <Link className="cy-link" to={s.to}>{s.label}</Link>
          {i < items.length - 1 ? ' · ' : ''}
        </React.Fragment>
      ))}
    </p>
  );
};

export default SiblingLinks;
